import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Either } from "@atlassiansox/flight-deck-core";
export class CdnHttpClientImpl {
  constructor() {
    _defineProperty(this, "baseUrl", "https://fd-config.us-east-1.prod.public.atl-paas.net");
  }
  async getBlob(tag, artifactName) {
    const endpoint = artifactName !== undefined ? `${this.baseUrl}/${artifactName}/${tag}` : `${this.baseUrl}/${tag}`;
    const response = await fetch(endpoint);
    if (!response.ok) {
      return Either.left({
        key: "unexpected-response-code",
        httpResponseCode: response.status,
        httpResponseStatusText: response.statusText
      });
    }
    return Either.right(await response.json());
  }
}